<template>
<base-modal v-model="isVisible" :title="$t('availabilityRequest.title')" @shown="showForm" @hidden="resetForm" :no-close-on-esc="noClose" :no-close-on-backdrop="noClose" :hide-header-close="noClose">
  <div class="text-center">
    <label v-html="$t('availabilityRequest.note')"></label>
    <base-select class="mb-4" clearable avoidDefaultSort :loading="form.appointmentType.loading" @input="typeAppointmentSelected" :options="form.appointmentType.options" valueProp="id" label="name" v-model="form.appointmentType.value" :placeholder="form.appointmentType.placeholder"></base-select>
    <base-select class="mb-4" clearable v-if="form.ratesRange.show" :loading="form.ratesRange.loading" :options="form.ratesRange.options" valueProp="id" label="name" v-model="form.ratesRange.value" :placeholder="form.ratesRange.placeholder"></base-select>
    <base-select class="mb-4" clearable v-if="showCenters" :loading="form.center.loading" :options="form.center.options" valueProp="id" label="name" v-model="form.center.value" :placeholder="form.center.placeholder"></base-select>
    <base-select class="mb-4" v-if="!hideFirstAppointmentSelector" clearable :loading="form.firstAppointment.loading" :options="form.firstAppointment.options" valueProp="id" label="name" v-model="form.firstAppointment.value" :placeholder="form.firstAppointment.placeholder"></base-select>
    <base-textarea v-model="form.availabilityDescription.value" :placeholder="form.availabilityDescription.placeholder"></base-textarea>
    <!-- <base-select class="mb-4" clearable :loading="form.haveInsurance.loading" @input="haveInsuranceSelected" :options="form.haveInsurance.options" valueProp="id" label="name" v-model="form.haveInsurance.value" :placeholder="form.haveInsurance.placeholder"></base-select> -->
    <base-select class="mb-4" clearable v-if="form.insurance.show" :loading="form.insurance.loading" :options="form.insurance.options" valueProp="name" label="name" v-model="form.insurance.value" :placeholder="form.insurance.placeholder"></base-select>
    <base-select class="mb-4" clearable avoidDefaultSort :loading="form.forWho.loading" @input="forWhoSelected" :options="form.forWho.options" valueProp="id" label="name" v-model="form.forWho.value" :placeholder="form.forWho.placeholder"></base-select>
    <base-select class="mb-4" clearable v-if="form.minorPatient.show" :loading="form.minorPatient.loading" :options="form.minorPatient.options" valueProp="id" label="name" v-model="form.minorPatient.value" :placeholder="form.minorPatient.placeholder"></base-select>
    <base-select class="mb-4" clearable v-if="form.pet.show" :loading="form.pet.loading" :options="form.pet.options" valueProp="id" label="name" v-model="form.pet.value" :placeholder="form.pet.placeholder"></base-select>
    <b-row>
        <b-col class="mb-4" cols="12" md="5"><base-select clearable v-model="form.phonePrefix.value" searchable :placeholder="$t('signupOH.registerPhonePrefix')" :options="form.phonePrefix.options" :label="$i18nHelpers.normalizeProp('prefixAndCountry')" valueProp="idCountry"></base-select></b-col>
        <b-col cols="12" md="7"><base-input v-model="form.phone.value" :placeholder="form.phone.placeholder"></base-input></b-col>
    </b-row>
    <base-textarea v-model="form.description.value" :placeholder="form.description.placeholder" :rows="5"></base-textarea>
    <base-checkbox v-if="medicalRequest" v-model="form.foreignPatient.value">
      <span v-html="$t('availabilityRequest.englishPrescription')"></span>
    </base-checkbox>
    <base-checkbox v-model="termsAccepted">
      <span v-html="$t('signupOH.accept-terms-patient')"></span>
    </base-checkbox>
    <VueRecaptcha class="custom-recaptcha" :sitekey="siteKey" :load-recaptcha-script="true" @verify="validCaptcha = true" @error="validCaptcha = false" @expired="validCaptcha = false"></VueRecaptcha>
    <base-button class="mt-4" @click="sendForm">{{$t('send')}}</base-button>
  </div>
</base-modal>
</template>

<script>
import { VueRecaptcha } from 'vue-recaptcha'
import { recaptcha } from '@/constants/recaptcha'
import BaseModal from '@/components/base/BaseModal.vue'
import appointmentsRepository from '@/repositories/AppointmentsRepository'
import insurersRepository from '@/repositories/InsurersRepository'
import geographyRepository from '@/repositories/GeographyRepository'
import specialitiesRepository from '@/repositories/SpecialitiesRepository'
import professionalAvailabilityRequestRepository from '@/repositories/ProfessionalAvailabilityRequestRepository'
import { INPLACE, VIDEO, AT_HOME } from '@/constants/consultationTypes'
import patientsRepository from '@/repositories/PatientsRepository'
import petRepository from '@/repositories/PetRepository'
import _ from 'lodash'
import { VETERINARIAN } from '@/constants/db/specialties'
import { MX_COUNTRY_ID, SPAIN_COUNTRY_ID } from '@/constants/db/countries'
import { getCurrencyByDomain } from '@/constants/currencies'
import { inMx, inEs } from '@/helpers/global.helpers'
import i18nMixin from '@/mixins/i18n.mixin'

const I18N_FILE = 'forms/availability-request'
const FOR_ME = 1
const FOR_MINOR = 2
const FOR_PET = 3

export default {
  components: {
    BaseModal,
    VueRecaptcha
  },
  props: {
    profId: String,
    specialties: Array,
    companyServices: Object,
    appointmentTypeSelected: Number,
    value: Boolean,
    noClose: Boolean,
    goRoot: Boolean
  },
  mixins: [i18nMixin(I18N_FILE)],
  data () {
    return {
      form: {
        appointmentType: {
            loading: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.appointmentType'),
            value: null
        },
        ratesRange: {
            loading: false,
            show: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.selectAService'),
            value: null,
            optionsGrouped: []
        },
        center: {
            loading: false,
            show: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.center'),
            value: null
        },
        firstAppointment: {
            loading: false,
            options: [{id: true, name: this.$t('yes')}, {id: false, name: this.$t('no')}],
            defaultOptions: [{id: true, name: this.$t('yes')}, {id: false, name: this.$t('no')}],
            placeholder: this.$t('availabilityRequest.form.firstAppointment'),
            value: null
        },
        availabilityDescription: {
            placeholder: this.$t('availabilityRequest.form.availabilityDescription'),
            value: null
        },
        haveInsurance: {
            loading: false,
            show: false,
            options: [{id: false, name: this.$t('single')}, {id: true, name: this.$t('insurance')}],
            defaultOptions: [{id: false, name: this.$t('single')}, {id: true, name: this.$t('insurance')}],
            placeholder: this.$t('availabilityRequest.form.haveInsurance'),
            value: false
        },
        insurance: {
            loading: false,
            show: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.insurance'),
            value: null
        },
        forWho: {
            loading: false,
            show: false,
            options: [{id: FOR_ME, name: this.$t('forMe')}, {id: FOR_MINOR, name: this.$t('forMinor')}],
            defaultOptions: [{id: FOR_ME, name: this.$t('forMe')}, {id: FOR_MINOR, name: this.$t('forMinor')}],
            placeholder: this.$t('availabilityRequest.form.forWho'),
            value: null
        },
        minorPatient: {
            loading: false,
            show: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.minorPatient'),
            value: null
        },
        pet: {
            loading: false,
            show: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.pet'),
            value: null
        },
        phonePrefix: {
            loading: false,
            options: [],
            value: null
        },
        phone: {
            loading: false,
            options: [],
            placeholder: this.$t('availabilityRequest.form.phone'),
            value: null
        },
        description: {
            placeholder: this.$t('availabilityRequest.form.description'),
            value: null
        },
        foreignPatient: {
            value: null
        }
      },
      termsAccepted: false,
      validCaptcha: false,
      medicalRequest: false,
      patientHaveMinors: false,
      patientIsMinor: false,
      hideFirstAppointmentSelector: false,
      siteKey: recaptcha
    }
  },
  methods: {
    showForm () {
      this.checkIfFirstAppointment()
      this.getAssociatedPatients()
      this.getActivesServices()
      this.loadPhonePrefixes()
      if (this.isVeterinarian) {
        if (!this.form.forWho.options.some(item => item.id === FOR_PET)) {
            this.form.forWho.options.push({id: FOR_PET, name: this.$t('forPet')})
        }
        this.form.forWho.value = null
        petRepository.getPatientPets().then(response => {
          if (response.data.data.length > 0) {
            this.form.pet.options = response.data.data.map(item => { return {name: `${item.name} (${this.$i18nHelpers.normalize(item.animalType)})`, id: item.idAnimal} })
          }
        })
      }
      specialitiesRepository.isMedicalProfessional(this.profId).then(response => {
        this.medicalRequest = response.data
      })
    },
    loadPhonePrefixes () {
      geographyRepository.getCountries().then(response => {
        this.form.phonePrefix.options = response.data
        this.form.phonePrefix.value = inMx ? MX_COUNTRY_ID : inEs ? SPAIN_COUNTRY_ID : null
      })
    },
    checkIfFirstAppointment () {
      appointmentsRepository.isFirstAppointment(this.profId).then(response => {
        if (response.data) {
          this.hideFirstAppointmentSelector = true
          this.form.firstAppointment.value = true
        }
      })
    },
    getAssociatedPatients () {
      patientsRepository.getAssociatedPatientsForRequest().then(response => {
        if (response.data.patients.length > 0) {
          if (response.data.isMinor) {
            this.patientHaveMinors = false
            this.form.forWho.value = FOR_ME
            this.patientIsMinor = true
          } else {
            this.patientHaveMinors = true
            this.patientIsMinor = false
            this.form.minorPatient.options = response.data.patients
          }
        } else {
          this.patientIsMinor = false
          this.patientHaveMinors = false
        }
			})
    },
    getCenters () {
      professionalAvailabilityRequestRepository.getActivesCenterToRequestAvailability(this.profId).then(response => {
        this.form.center.options = response.data
      })
    },
    getInsurers () {
      insurersRepository.getInsurers().then(response => {
        this.form.insurance.options = response.data
      })
    },
    getActivesServices () {
      this.form.appointmentType.options = []
      if (this.$store.state.inOpensalud360) {
        this.form.appointmentType.options = [{id: INPLACE, name: this.$t('services-title.type-one')}, {id: VIDEO, name: this.$t('services-title.type-two')}]
      } else {
        professionalAvailabilityRequestRepository.getActivesServices(this.profId).then(response => {
          let data = response.data
          if ((!data || (!data.inplace && !data.video && !data.atHome)) && (!this.companyServices[INPLACE] && !this.companyServices[VIDEO] && !this.companyServices[AT_HOME])) {
              this.form.appointmentType.options.push({ id: INPLACE, name: this.$t('services-title.type-one') })
          } else if (data) {
            if ((data.inplace || this.companyServices[INPLACE])) this.form.appointmentType.options.push({ id: INPLACE, name: this.$t('services-title.type-one') })
            if ((data.video || this.companyServices[VIDEO])) this.form.appointmentType.options.push({ id: VIDEO, name: this.$t('services-title.type-two') })
            if ((data.atHome || this.companyServices[AT_HOME])) this.form.appointmentType.options.push({ id: AT_HOME, name: this.$t('services-title.type-six') })
            if (data.multiRates && data.multiRates.length > 0) {
              this.form.ratesRange.optionsGrouped = _.groupBy(data.multiRates, item => { return item.serviceType })
              if (this.appointmentTypeSelected === INPLACE || this.appointmentTypeSelected === VIDEO) {
                  this.typeAppointmentSelected()
              }
            } else {
              this.form.ratesRange.optionsGrouped = []
              this.form.ratesRange.options = []
              this.form.ratesRange.show = false
            }
          }
          this.form.appointmentType.value = this.appointmentTypeSelected
        })
      }
    },
    typeAppointmentSelected () {
      if (this.form.appointmentType.value !== INPLACE) this.form.center.value = null
      if (this.form.ratesRange.optionsGrouped && this.form.ratesRange.optionsGrouped[this.appointmentTypeSelected] && this.form.ratesRange.optionsGrouped[this.appointmentTypeSelected].length > 0 && (this.appointmentTypeSelected === INPLACE || this.appointmentTypeSelected === VIDEO)) {
        this.form.ratesRange.options = this.form.ratesRange.optionsGrouped[this.appointmentTypeSelected].map(item => {
            return { name: `${item.description}${this.$store.state.inOpensalud360 ? '' : ` ${item.price}${getCurrencyByDomain()}`}`, id: item.Id }
        })
        this.form.ratesRange.show = true
      } else {
        this.form.ratesRange.show = false
      }
    },
    haveInsuranceSelected () {
      if (this.form.haveInsurance.value && this.form.insurance.options.length === 0) this.getInsurers()
      this.form.insurance.show = this.form.haveInsurance.value
    },
    forWhoSelected () {
      if (this.isVeterinarian && this.form.forWho.value !== FOR_PET) {
        this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.mustSelectPet'))
        this.form.forWho.value = null
        this.form.pet.show = false
      } else if (this.isVeterinarian && this.form.forWho.value === FOR_PET) {
        this.form.pet.show = true
      } else if (this.form.forWho.value === FOR_MINOR && this.patientHaveMinors) {
        this.form.minorPatient.show = true
        if (!this.form.minorPatient.options.length) {
          this.getAssociatedPatients()
        }
      } else {
        this.form.minorPatient.show = false
      }
    },
    sendForm () {
      if (!this.form.appointmentType.value) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.typeAppointment'))
      } else if (this.form.firstAppointment.value === null) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.firstAppointment'))
      } else if (this.form.appointmentType.value === INPLACE && !this.companyServices[INPLACE] && this.form.haveInsurance.value === null) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.selectInsurance'))
      } else if (this.form.insurance.value === null && !this.companyServices[INPLACE] && this.form.haveInsurance.value) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.insurance'))
      } else if (!this.form.forWho.value || (this.form.forWho.value === FOR_MINOR && !this.form.minorPatient.value)) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.forWho'))
      } else if (this.isVeterinarian && !this.form.pet.value) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.selectPet'))
      } else if (!this.form.phonePrefix.value) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.phonePrefix'))
      } else if (!this.form.phone.value || this.$validators.validate(this.form.phone.value, ['phone']) === false) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.phone'))
      } else if (!this.form.description.value) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.description'))
      } else if (!this.termsAccepted) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.terms'))
      } else if (!this.validCaptcha) {
          this.$store.dispatch('showInfoAlert', this.$t('availabilityRequest.error.captcha'))
      } else {
        let data = {
          profId: this.profId,
          phonePrefix: this.form.phonePrefix.value,
          phone: this.form.phone.value,
          request: this.form.description.value,
          insurance: this.form.insurance.value,
          appointmentType: this.form.appointmentType.value,
          isFirstAppointment: this.form.firstAppointment.value,
          appointmentDate: this.form.availabilityDescription.value,
          centerId: this.form.center.value,
          minorPatientId: this.form.minorPatient.value,
          petId: this.form.pet.value,
          multiPriceId: this.form.ratesRange.value,
          foreignPatient: this.form.foreignPatient.value
        }
        professionalAvailabilityRequestRepository.sendAvailabilityRequest(data).then(response => {
          if (response.data) {
            this.$store.dispatch('showSuccessAlert', this.$t('availabilityRequest.success'))
          } else {
            this.$store.dispatch('showDangerAlert', this.$t('error.try-again'))
          }
          this.resetForm()
          this.isVisible = false
          if (this.goRoot) {
            setTimeout(() => {
              this.$router.push('/patient')
            }, 3000)
          }
        })
      }
    },
    resetForm () {
      Object.keys(this.form).forEach(key => {
        this.form[key].value = this.form[key].defaultValue ? this.form[key].defaultValue : null
        this.form[key].options = this.form[key].defaultOptions ? this.form[key].defaultOptions : []
        this.form[key].show = false
      })
      this.termsAccepted = false
      this.validCaptcha = false
      this.medicalRequest = false
      this.patientHaveMinors = false
      this.patientIsMinor = false
    }
  },
  computed: {
    showCenters () {
      if (this.form.appointmentType.value === INPLACE && !this.form.ratesRange.show) {
        this.getCenters()
        return true
      }
      return false
    },
		isVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
		},
    isVeterinarian () {
      return this.specialties.some(item => item.id === VETERINARIAN)
    }
	}
}
</script>

<style lang="scss" scoped>
/deep/ .custom-recaptcha > div {
  width: auto !important;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/AvailabilityRequestModal.vue